import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import config from 'SRC/config/config.json'

export const ChoosePackage = ({ packages, onChangePackage, selectedPackage }) => {
  const { t } = useTranslation('common')

  return (
    <tr>
      <td><strong>{t(config.registrationForm.package.choosePackage[0])}</strong></td>
      {
        packages.map(
          item => item.id === selectedPackage
            ? <td key={item.id} className='izabran-paket'>
              <a href='javascript: void (0)'>
                {t(config.registrationForm.package.choosePackage[1])}
              </a>
            </td>
            : <td key={item.id}>
              <a data-id={item.id} onClick={onChangePackage} href='javascript: void (0)'>
                {t(config.registrationForm.package.choosePackage[2])}
              </a>
            </td>
        )
      }
    </tr>
  )
}

ChoosePackage.propTypes = {
  packages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired
  })).isRequired,
  onChangePackage: PropTypes.func.isRequired,
  selectedPackage: PropTypes.number
}

ChoosePackage.defaultProps = {
  packages: []
}
